/**
 * 体験詳細ページのパスを組み立てる（末尾スラッシュ付き）。
 * マップのピンカード・プレビューカード等、複数箇所での `/experiences/${slug}/` 直書きを一元化する。
 *
 * @param {string} slug - 体験のスラッグ
 * @returns {string} 体験詳細ページのパス（例: `/experiences/kyoto-tea/`）
 */
export const buildExperienceDetailPath = (slug: string): string => `/experiences/${slug}/`;
